export const ProductElementLine = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.63828 15.8C5.96558 15.8 2.98828 12.8227 2.98828 9.15C2.98828 5.4773 5.96558 2.5 9.63828 2.5C13.311 2.5 16.2883 5.4773 16.2883 9.15"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M21.5121 9.1499H9.16211V21.4999H21.5121V9.1499Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
